export default __webpack_public_path__ + "static/media/14637.masterclass-committee.photo.0ac1ce33.jpg";